import { render, staticRenderFns } from "./NewsAlt.vue?vue&type=template&id=0ddcf0f7"
import script from "./NewsAlt.vue?vue&type=script&lang=js"
export * from "./NewsAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports